import { ByodProps } from "./Byod";
import { Box, ClickAwayListener, Grid, Stack, Typography } from "@mui/material";
import { ButtonCust } from "../../widgets/Button/ButtonCust";
import EnvConfig from "../../../config/env.config.json";
import { pushTrackingEventsToGAAndFB } from "../../../utils/commonFunctions/GaAndFb";
import {
  gaEventTypes,
  gaScreenNames,
  gaCategory,
} from "../../../Types/GoogleAnalytics";
import {
  CustToolTip,
  LazyLoadImageCust,
  SimpleModal,
  TextFieldCust,
} from "../../widgets";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";
import { useState } from "react";
import {
  checkCompatibility,
  getInTouchApi,
} from "../../../features/homepage/homepageSlice";
import {
  PhoneNoPattern,
  digitsOnlyPattern,
} from "../../../utils/regexPatterns";
import {
  renderTextStyles,
  useNonInitialEffect,
} from "../../../utils/commonFunctions";
import { scroller } from "react-scroll";
import ApnNote from "../../apnSettings/Apn_Note";
import styles from "./S1_Byod.module.scss";
import _ from "lodash";
import { object } from "yup";

const T3_ByodComponent = (props: ByodProps) => {
  const {
    tick_icon,
    title,
    desc,
    btn_1,
    img_web,
    img_mweb,
    imei_label,
    limit_imei,
    imei_err,
    heading,
    sub_heading,
    success_msg,
    btn_2,
    byod_fail_title,
    byod_fail_subtitle,
    byod_fail_btn,
    web_img_left,
    cncl_icon,
    imei_error_img,
    imei_error_modal,
  } = props?.byodContent || {};
  const dispatch = useAppDispatch();
  const { compatibility, errorCompatibility, compatibilityLoading } =
    useAppSelector((state: any) => state.homepage);
  const { imeiData, subDomainData } = useAppSelector(
    (state: any) => state?.homepage
  );
  const [showCheckIMEIModal, setShowCheckIMEIModal] = useState(false);
  const [imeiNumber, setimeiNumber] = useState("");
  const [imeiErr, setImeiErr] = useState("");
  const [isCompatible, setisCompatible] = useState(false);
  const [errorInCompat, setErrorInCompat] = useState(false);
  const [IMEIOpenInfo, setIMEIOpenInfo] = useState(false);
  const [imeiBtnLoader, setImeiBtnLoader] = useState(false);
  const [imeiErrorModal, setImeiErrorModal] = useState(false);
  const [errModalMsg, setErrModalMsg] = useState("");
  const [imeiModel, setImeiModel] = useState("");
  const currentUser = JSON.parse(
    localStorage.getItem("currentuser") || "[]"
  ) as any;

  // useNonInitialEffect(() => {
  //   if (
  //     compatibility?.data?.status === "SUCCESS" &&
  //     compatibility?.data?.data
  //   ) {
  //     if (compatibility?.data?.data?.isValid) {
  //       setErrorInCompat(false);
  //       setisCompatible(true);
  //     } else {
  //       setErrorInCompat(true);
  //       if (currentUser?.email) {
  //         const hubspotPy = {
  //           emailId: currentUser?.email,
  //           hubspotMap: {
  //             device_imei: imeiNumber,
  //             website_imei_incompatibility_reason: "",
  //             is_test: EnvConfig?.IS_HUBSPOT_TEST_ENV,
  //             is_qa: EnvConfig?.IS_HUBSPOT_QA_ENV,
  //             brand_name:
  //               subDomainData?.data?.brandName || EnvConfig.BRAND_NAME,
  //           },
  //         };
  //         dispatch(
  //           getInTouchApi({
  //             data: {
  //               ...hubspotPy,
  //               hubspotMap: {
  //                 ...hubspotPy.hubspotMap,
  //                 website_imei_incompatibility_reason: "IMEI Invalid",
  //               },
  //             },
  //           })
  //         );
  //       }
  //     }
  //   }
  // }, [compatibility]);

  const GAAndFBEventsHandler = (category: string, value: string) => {
    pushTrackingEventsToGAAndFB(gaEventTypes.event, gaEventTypes.click, {
      appName: EnvConfig.brand,
      screenName: gaScreenNames.plan,
      category: category,
      buttonValue: value,
    });
  };

  const ImeiCheckHandler = async () => {
    if (
      imeiNumber &&
      imeiErr === "" &&
      imeiNumber.length === 15 &&
      /^\d+$/.test(imeiNumber)
    ) {
      setImeiBtnLoader(true);
      dispatch(checkCompatibility({ imeiNumber: imeiNumber })).then(
        (response: any) => {
          let compatibilityData = response?.payload?.data?.data;
          if (response?.payload?.status === 200 && compatibilityData) {
            if (compatibilityData?.inProgress) {
              setTimeout(() => {
                // call api
                ImeiCheckHandler();
              }, 10000);
            } else if (
              response?.payload?.status === 200 &&
              response?.payload?.data?.data?.isValid
            ) {
              setImeiBtnLoader(false);
              setErrorInCompat(false);
              setisCompatible(true);
            } else if (
              (response?.payload?.status === 200 &&
                !response?.payload?.data?.data?.isValid) ||
              response?.error?.code
            ) {
              setImeiBtnLoader(false);
              setImeiModel(response?.payload?.data?.data?.model);
              if (
                response?.payload?.data?.data?.isLostOrStolen?.toLowerCase() ===
                "yes"
              ) {
                setErrModalMsg(imei_error_modal?.lostImei);
                setImeiErrorModal(true);
              } else if (
                response?.payload?.data?.data?.isLocked?.toLowerCase() === "yes"
              ) {
                setErrModalMsg(imei_error_modal?.lockedImei);
                setImeiErrorModal(true);
              } else if (
                response?.payload?.data?.data?.filteredDevice?.toLowerCase() ===
                "yes"
              ) {
                setErrModalMsg(imei_error_modal?.filteredImei);
                setImeiErrorModal(true);
              } else {
                setErrorInCompat(true);
              }
              if (currentUser?.email) {
                const hubspotPy = {
                  emailId: currentUser?.email,
                  hubspotMap: {
                    device_imei: imeiNumber,
                    website_imei_incompatibility_reason: "",
                    is_test: EnvConfig?.IS_HUBSPOT_TEST_ENV,
                    is_qa: EnvConfig?.IS_HUBSPOT_QA_ENV,
                    brand_name:
                      subDomainData?.data?.brandName || EnvConfig.BRAND_NAME,
                  },
                };
                dispatch(
                  getInTouchApi({
                    data: {
                      ...hubspotPy,
                      hubspotMap: {
                        ...hubspotPy.hubspotMap,
                        website_imei_incompatibility_reason: "IMEI Invalid",
                      },
                    },
                  })
                );
              }
            }
          }
        }
      );
    } else {
      setImeiBtnLoader(false);
      setErrorInCompat(true);
      if (imeiNumber === "") {
        setImeiErr(imei_err.err_3);
      } else if (imeiNumber !== "" && imeiNumber.length !== 15) {
        setImeiErr(imei_err.err_2);
      } else if (imeiNumber !== "" && !/^\d+$/.test(imeiNumber)) {
        setImeiErr(imei_err.err_1);
      }
    }
  };

  const onChangeHandler = (e: any) => {
    setimeiNumber(e.target.value);
    setImeiErr("");
  };

  const seePlansHandler = () => {
    closeModalHandler();
    scroller.scrollTo("bestCellPhonePlan", {
      duration: 1000,
      delay: 0,
      offset: -100,
      smooth: true,
    });
  };

  const closeModalHandler = () => {
    setimeiNumber("");
    setisCompatible(false);
    setErrorInCompat(false);
    setImeiErrorModal(false);
    setShowCheckIMEIModal(false);
  };

  const tryAgainHandler = () => {
    setimeiNumber("");
    setErrorInCompat(false);
    setImeiErrorModal(false);
    setShowCheckIMEIModal(true);
  };
  const handleCheckPhone = () => {
    setisCompatible(false);
  };
  const PoperOver = (data: any) => {
    return (
      <ClickAwayListener
        onClickAway={() => {
          openIMEIPopper(false);
        }}
      >
        <Box
          component="a"
          target="_blank"
          sx={{
            color: "var(--white)",
            fontFamily: "var(--font_family_Medium) !important",
            fontSize: "14px",
          }}
        >
          {data}
        </Box>
      </ClickAwayListener>
    );
  };
  const openIMEIPopper = (data: any) => {
    setIMEIOpenInfo(data);
  };
  return (
    props?.byodContent && (
      <>
        <Grid
          container
          display="flex"
          flexDirection={web_img_left ? "row-reverse" : "unset"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{
            // pl: { xs: "", sm: "130px" },
            // pr: { xs: "", sm: "30px" },
            // px: { xs: 4, md: 8 },
            px: { xs: 4, sm: 0 },
            backgroundColor: "var(--app_section_bg_color)",
          }}
        >
          <Grid
            item
            md={8}
            xs={12}
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent={"space-between"}
          >
            <Grid
              item
              // md={6}
              sx={{
                m: { xs: "0px", sm: "20px 0" },
                px: { xs: 0 },
                pl: { sm: "7px" },
                maxWidth: { sm: "350px" },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  color: "var(--black)",
                  lineHeight: { md: "50px" },
                  fontSize: { xs: "26px", md: "30px" },
                  fontFamily: "var(--font_family_Bold)",
                  fontWeight: "var(--font_weight_4)",
                  mb: { xs: "20px", md: "15px" },
                  mt: { xs: "30px" },
                }}
              >
                {BrandNameUpdate(title)}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  textAlign: { xs: "center", sm: "left" },
                  color: "var(--text_color)",
                  fontSize: { xs: "14px" },
                  lineHeight: "25px",
                  fontFamily: "var(--font_family_Regular)",
                  mb: { xs: "20px", md: "25px" },
                }}
              >
                {BrandNameUpdate(desc)}
              </Typography>
              <ButtonCust
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                onClick={() => {
                  setShowCheckIMEIModal(true);
                  GAAndFBEventsHandler(gaCategory.networkCompatible, btn_1);
                }}
                sx={{
                  width: "250px",
                  display: "block",
                  margin: { xs: "auto", md: "0" },
                }}
              >
                {btn_1}
              </ButtonCust>
            </Grid>
            <Grid
              item
              // md={6}
              sx={{
                display: { xs: "none", sm: "flex" },
                justifyContent: "center",
                // width: "100%",
              }}
            >
              <LazyLoadImageCust
                src={
                  subDomainData?.data?.smallImage1Url
                    ? subDomainData?.data?.smallImage1Url
                    : img_web?.data?.attributes?.url
                }
                alt={BrandNameUpdate(
                  img_web?.data?.attributes?.alternativeText
                )}
                style={{
                  maxWidth: "362px",
                  width: "95%",
                  objectFit: "contain",
                  height: "100%",
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: { xs: "flex", sm: "none" },
                justifyContent: "center",
                pt: { xs: "20px", md: "unset" },
              }}
            >
              <LazyLoadImageCust
                src={
                  subDomainData?.data?.smallImage1Url
                    ? subDomainData?.data?.smallImage1Url
                    : img_mweb?.data?.attributes?.url
                }
                alt={BrandNameUpdate(
                  img_mweb?.data?.attributes?.alternativeText
                )}
                style={{ maxWidth: "362px", width: "85%", paddingTop: "10px" }}
              />
            </Grid>
          </Grid>
        </Grid>
        <SimpleModal
          isShowModal={showCheckIMEIModal}
          onCloseModal={() => closeModalHandler()}
          showClose={true}
          sx={{
            width: {
              xs: "95%",
              sm: "70%",
              md: "80%",
              lg: "646px",
              xl: EnvConfig?.IS_CHECK_COMPATIBILITY_APPLE_SETTINGS
                ? "46%"
                : "30%",
            },
            padding: { xs: "30px 15px", sm: "30px" },
            borderRadius: "4px",
          }}
        >
          {!isCompatible && !errorInCompat && !imeiErrorModal ? (
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                component="h3"
                sx={{
                  fontSize: "22px !important",
                  lineHeight: { sm: "36px" },
                  fontFamily: "var(--font_family_Bold)",
                  fontWeight: "var(--font_weight_custom2)",
                  mb: "20px",
                  color: "var(--title-color_1)",
                }}
              >
                {BrandNameUpdate(heading)}
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "16px", sm: "18px !important" },
                  fontFamily: "var(--font_family_Medium)",
                  color: "var(--text_color)",
                  fontWeight: "var(--font_weight_1) !important",
                  textAlign: "center",
                  width: { xs: "100%", sm: "80%" },
                  marginBottom: "25px",
                }}
              >
                {BrandNameUpdate(sub_heading)}
              </Typography>
              <Box
                onKeyDown={(e: any) => {
                  if (e.key === "Enter") {
                    ImeiCheckHandler();
                  }
                }}
                sx={{ width: "100%", maxWidth: "430px", mb: "22px" }}
              >
                <TextFieldCust
                  value={imeiNumber}
                  type={window.screen.width <= 600 ? "number" : "text"}
                  label={imei_label}
                  onChange={(e: any) => {
                    if (
                      (PhoneNoPattern.test(e.target.value) &&
                        e.target.value.length <= 15) ||
                      e.target.value === ""
                    ) {
                      onChangeHandler(e);
                    }
                  }}
                  error={
                    imeiErr !== "" ||
                    (imeiNumber !== "" &&
                      !digitsOnlyPattern.test(imeiNumber)) ||
                    (imeiNumber !== "" && imeiNumber.length !== 15) ||
                    (imeiBtnLoader && imeiNumber === "")
                  }
                  helperText={
                    imeiErr
                      ? imeiErr
                      : imeiNumber !== "" && !digitsOnlyPattern.test(imeiNumber)
                      ? imei_err.err_1
                      : imeiNumber !== "" && imeiNumber.length !== 15
                      ? imei_err.err_2
                      : imeiBtnLoader && imeiNumber === ""
                      ? imei_err.err_3
                      : ""
                  }
                  maxLength={15}
                />
                <Typography
                  component={"span"}
                  sx={{
                    color: "var(--black)",
                    display: "flex",
                    justifyContent: "end",
                    position: "relative",
                    fontFamily: "var(--font_family_Regular)",
                    fontWeight: "var(--font_weight_0)",
                    fontSize: "12px",
                    lineHeight: "25px",
                    top:
                      imeiErr !== "" ||
                      (imeiNumber !== "" &&
                        !digitsOnlyPattern.test(imeiNumber)) ||
                      (imeiNumber !== "" && imeiNumber.length !== 15) ||
                      (imeiBtnLoader && imeiNumber === "")
                        ? "-22px"
                        : "0px",
                  }}
                >
                  {imeiNumber && imeiNumber.length ? imeiNumber.length : "0"}
                  {limit_imei}
                </Typography>
              </Box>
              <ButtonCust
                sx={{
                  width: { xs: "65%", sm: "250px" },
                  fontFamily: "var(--font_family_Medium)",
                  fontSize: "14px",
                  fontWeight: "var(--font_weight_2) !important",
                  mb: props?.byodContent?.res?.what_is_imei ? "25px" : "0px",
                }}
                onClick={() => ImeiCheckHandler()}
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                loading={imeiBtnLoader}
              >
                {btn_1}
              </ButtonCust>
              {props?.byodContent?.res?.what_is_imei ? (
                <>
                  <CustToolTip
                    title={PoperOver(
                      <Box
                        sx={{
                          padding: "7px 19px 0px 20px",
                          maxHeight: "400px", // Set the max height to a specific value (adjust as necessary)
                          overflowY: "auto", // Enable vertical scrolling if content overflows
                          // wordWrap: "break-word",
                        }}
                      >
                        {props?.byodContent?.res?.imei_modal?.length > 0 &&
                          props?.byodContent?.res?.imei_modal?.map(
                            (data: any, index: string) => {
                              return (
                                <Box
                                  key={index}
                                  sx={{
                                    pb: "15px",
                                    "& span": { letterSpacing: "0px" },
                                  }}
                                >
                                  <Typography
                                    component={"span"}
                                    sx={renderTextStyles(
                                      1,
                                      "14px",
                                      "white",
                                      "28px",
                                      "var(--font_weight_4)"
                                    )}
                                  >
                                    {data?.title}
                                  </Typography>
                                  &nbsp;
                                  <Typography
                                    component={"span"}
                                    sx={renderTextStyles(
                                      4,
                                      "14px",
                                      "white",
                                      "22px",
                                      "var(--font_weight_0)"
                                    )}
                                  >
                                    {data?.desc}
                                  </Typography>
                                </Box>
                              );
                            }
                          )}
                      </Box>
                    )}
                    open={IMEIOpenInfo ? true : false}
                    disableFocusListener
                    disableHoverListener
                    arrow
                    placement={"top"}
                    className={styles?.tooltip_style}
                    PopperProps={{
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 10],
                          },
                        },
                      ],
                    }}
                  >
                    <Typography
                      sx={_.merge(
                        renderTextStyles(
                          3,
                          "16px",
                          "text_color",
                          "28px",
                          "var(--font_weight_1)"
                        ),
                        {
                          cursor: "pointer",
                          marginBottom: "20px",
                        }
                      )}
                      onMouseEnter={() => {
                        openIMEIPopper(true);
                      }}
                      onClick={() => {
                        openIMEIPopper(true);
                      }}
                      onMouseLeave={() => {
                        openIMEIPopper(false);
                      }}
                    >
                      {props?.byodContent?.res?.what_is_imei}
                    </Typography>
                  </CustToolTip>
                </>
              ) : null}
            </Stack>
          ) : null}
          {errorInCompat ? (
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {cncl_icon && (
                <Box
                  component="img"
                  sx={{ marginBottom: "20px" }}
                  alt={cncl_icon?.data?.attributes.alternativeText || ""}
                  src={cncl_icon?.data?.attributes.url || ""}
                />
              )}
              <Typography
                component="h3"
                sx={{
                  fontSize: "24px",
                  color: "var(--black) ",
                  fontFamily: "var(--font_family_Bold)",
                  fontWeight: "var(--font_weight_4)",
                  mb: "20px",
                }}
              >
                {byod_fail_title}
              </Typography>
              <Typography
                component="span"
                sx={{
                  fontSize: { xs: "13px", sm: "18px" },
                  fontFamily: "var(--font_family_Medium)",
                  color: "var(--text_color)",
                  fontWeight: "var(--font_weight_1)",
                  textAlign: "center",
                  width: "100%",
                  marginBottom: "20px",
                }}
              >
                {byod_fail_subtitle}
              </Typography>
              <ButtonCust
                sx={{
                  width: { xs: "65%", sm: "250px" },
                  fontFamily: "var(--font_family_Semibold) !important",
                  fontSize: "18px",
                  fontWeight: "var(--font_weight_2)",
                  my: "10px",
                }}
                onClick={() => tryAgainHandler()}
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
              >
                {byod_fail_btn}
              </ButtonCust>
            </Stack>
          ) : null}
          {isCompatible ? (
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                component="img"
                alt={tick_icon?.data?.attributes?.alternativeText}
                src={tick_icon?.data?.attributes?.url}
                sx={{
                  m: EnvConfig?.IS_CHECK_COMPATIBILITY_APPLE_SETTINGS
                    ? "0px 0px 20px"
                    : "20px 0px",
                }}
              />
              <Typography
                component="h3"
                sx={{
                  fontSize: { xs: "18px", sm: "24px !important" },
                  fontFamily: "var(--font_family_Bold)",
                  fontWeight: "var(--font_weight_custom2)",
                  mb: "20px",
                  color: "var(--title-color_1)",
                  textAlign: "center",
                }}
              >
                {BrandNameUpdate(success_msg)}
              </Typography>
              {EnvConfig?.IS_CHECK_COMPATIBILITY_APPLE_SETTINGS ? (
                <>
                  <Typography
                    component="h3"
                    sx={{
                      fontSize: "16px !important",
                      lineHeight: { xs: "18px", sm: "28px" },
                      fontFamily: "var(--font_family_Semibold) !important",
                      fontWeight: "var(--font_weight_2) !important",
                      mb: "20px",
                      color: "var(--primary_color)",
                      cursor: "pointer",
                    }}
                    onClick={handleCheckPhone}
                  >
                    {BrandNameUpdate(props?.byodContent?.ck_an_ph)}
                  </Typography>
                  {EnvConfig?.IS_APN_SETTINGS_ENABLED && imeiData?.os ? (
                    <Box pt={"15px"}>
                      <ApnNote
                        imeiData={{
                          os: imeiData?.os,
                          osVer: imeiData?.osVer,
                        }}
                        isShowAsPill={false}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        marginX: "0%",
                        padding: "20px",
                        mb: "30px",
                        backgroundColor: "var(--light_beige)",
                        borderRadius: "4px",
                        border: "1px solid var(--translucent_orange)",
                        boxShadow: " 0px 0px 27px 0px var(--translucent_gray)",
                      }}
                    >
                      <Typography
                        component="h3"
                        sx={{
                          fontSize: "16px !important",
                          lineHeight: { xs: "24px", sm: "29px" },
                          fontFamily: "var(--font_family_Medium)  !important",
                          fontWeight: "var(--font_weight_1)  !important",
                          pb: "20px",
                          color: "var(--black)",
                          textAlign: "left",
                        }}
                      >
                        {BrandNameUpdate(
                          compatibility?.data?.data?.os !== "ios"
                            ? props?.byodContent?.im_cr_an
                            : props?.byodContent?.im_cr_ip
                        )}
                      </Typography>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html:
                            compatibility?.data?.data?.os !== "ios"
                              ? props?.byodContent?.a_nxt_lnk
                              : props?.byodContent?.acc_nxt_lnk,
                        }}
                        sx={{
                          fontSize: "14px !important",
                          lineHeight: { xs: "18px", sm: "25px" },
                          fontFamily: "var(--font_family_Regular)  !important",
                          fontWeight: "var(--font_weight_0)  !important",
                          color: "var(--text_color)",
                          "& a": {
                            fontFamily: "var(--font_family_Medium)  !important",
                            fontWeight: "var(--font_weight_1)  !important",
                            color: "var(--primary_color)",
                          },
                        }}
                      />
                    </Box>
                  )}
                </>
              ) : (
                <ButtonCust
                  sx={{
                    width: { xs: "65%", sm: "250px" },
                    fontFamily: "var(--font_family_Medium)",
                    fontSize: "18px",
                    fontWeight: "var(--font_weight_2)",
                    my: "10px",
                  }}
                  onClick={() => seePlansHandler()}
                  variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                >
                  {btn_2}
                </ButtonCust>
              )}
            </Stack>
          ) : null}

          {/* lost/locked/blacklisted imei */}
          {imeiErrorModal ? (
            <Box sx={{ textAlign: "center", maxWidth: "600px" }}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  alt={imei_error_img?.data?.attributes?.alternativeText || ""}
                  src={imei_error_img?.data?.attributes?.url || ""}
                  sx={{ display: "flex" }}
                />
              </Box>

              {compatibility && (
                <Typography
                  sx={{
                    mt: "20px",
                    fontSize: "18px",
                    fontWeight: 400,
                    textAlign: "center",
                    fontFamily: "var(--font_family_Regular) !important",
                    color: "var(--black)",
                    "& strong": {
                      fontFamily: "var(--font_family_Bold) !important",
                      fontWeight: 700,
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: errModalMsg?.replace(
                      "{brandModel}",
                      `<strong>${imeiModel}</strong>`
                    ),
                  }}
                ></Typography>
              )}

              <ButtonCust
                variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                onClick={() => tryAgainHandler()}
                sx={{
                  mt: "30px",
                  mb: "10px",
                  width: { xs: "fit-content", sm: "250px" },
                }}
              >
                {imei_error_modal?.btnText1}
              </ButtonCust>
            </Box>
          ) : null}
        </SimpleModal>
      </>
    )
  );
};
export default T3_ByodComponent;
